module.exports = __webpack_public_path__ + "img/newsImg.e1628189.png";